import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rdsFilterFields'
})
export class RdsFilterFieldsPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
